import { useEffect, useState } from "react";
import MyInvitesCard from "./MyInvitesCard";
import "./MyInvitesSection.css";
import { API_BASE_URL } from "../utils";
import axios from "axios";
import MybookingCardSkeleton from "./customComp/MybookingCardSkeleton";

export default function MyInvitesSection() {
  const [invitePending, setInvitePending] = useState([]);
  const [inviteComplete, setInviteComplete] = useState([]);
  const [isLoading, setIsLoading] = useState(true);

  const userdata = JSON.parse(localStorage.getItem("userData"));

  const fetchInviteData = async (type, setter) => {
    const formData = new FormData();
    formData.append("user_id", userdata.id);
    formData.append("type", type);

    try {
      const response = await axios.post(
        `${API_BASE_URL}/master/APIs/ClubPackage/inviteePartyDetails`,
        formData
      );

      if (response.data?.status) {
        const data = response.data.data;

        if (Array.isArray(data)) {
          setter(data);
        } else if (data) {
          setter([data]);
        } else {
          setter([]);
        }
      } else {
        setter([]);
      }
    } catch (error) {
      console.error("Error fetching data:", error);
      setter([]);
    }
  };

  useEffect(() => {
    async function load() {
      setIsLoading(true);
      await Promise.all([
        fetchInviteData("pending", setInvitePending),
        fetchInviteData("Complete", setInviteComplete),
      ]);
      setIsLoading(false);
    }
    load();
  }, []);

  const renderEmpty = (text = "No Party is active for you.") => (
    <div className="mbpswc-content-temp">
      <h2>{text}</h2>
    </div>
  );

  const renderSkeletons = (count = 2) =>
    Array.from({ length: count }).map((_, i) => (
      <MybookingCardSkeleton key={`s-${i}`} />
    ));

  return (
    <div className="miv-card-container-section">
      {/* Pending Section */}
      <div className="invite-section">
        <h3 className="mbpswc-content-title">Upcoming</h3>
        {isLoading ? (
          renderSkeletons()
        ) : invitePending.length > 0 ? (
          invitePending.map((invite, index) => (
            <MyInvitesCard key={`pending-${index}`} invite={invite} />
          ))
        ) : (
          renderEmpty("No upcoming party invites found.")
        )}
      </div>

      {/* Complete Section */}
      <div className="invite-section">
        <h3 className="mbpswc-content-title">History</h3>
        {isLoading ? (
          renderSkeletons()
        ) : inviteComplete.length > 0 ? (
          inviteComplete.map((invite, index) => (
            <MyInvitesCard key={`complete-${index}`} invite={invite} />
          ))
        ) : (
          renderEmpty("No past party invites found.")
        )}
      </div>
    </div>
  );
}
